/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Mcp_More_ApiInputs */

const en_directory_mcp_more_api = /** @type {(inputs: Directory_Mcp_More_ApiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API reference`)
};

const zh_directory_mcp_more_api = /** @type {(inputs: Directory_Mcp_More_ApiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API 参考`)
};

/**
* | output |
* | --- |
* | "API reference" |
*
* @param {Directory_Mcp_More_ApiInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_mcp_more_api = /** @type {((inputs?: Directory_Mcp_More_ApiInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Mcp_More_ApiInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_mcp_more_api(inputs)
	return zh_directory_mcp_more_api(inputs)
});
export { directory_mcp_more_api as "directory.mcp.more_api" }